module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEdSURBVHgBxVPBjcIwEJyYe0R8oITkcyd+dx1cOvBRAVcBJUAHiAqABlA6IB2QXwQfKCF8EOKxZuMAiUQgCQQYydZ6vTvZeHeAt0AGHb0K4KNIEIQYHa1xbigqRlKhnDcB8zu52vlwf8LMrBuxCWGtPoNCEkSmw7uXSRiRCTE7H1Xd5484EWlMKAMrRbZGLmpcjTrFWTA412g02A4vmzL9spEH99PnPY5rL1T66olNyUI8e17qbHEJv5i2xtdSrlcoV009f+nHF2LO20ATlyZ07RBE/xd+oj+4rXV5Qk3Kv0bkQNFEL9ra7PNupeRLL66mg4KovMsvGJt20MfjhCZLaR+Jm0UveigPnojNJjKMs0suWfDo4h4Qhkc5Vo8DpD1UW6I9rHsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/prow4.png
// module id = LBnD
// module chunks = 0